import {
  Image,
  FooterContainer,
  LinkText,
  FooterText,
  CenterContainer,
  Divider,
  LogosContainer,
  CertificationsImage,
  CertificationsContainer,
  TextDivider,
} from './styles/FooterStyles';
import { useHistory } from 'react-router';

import LogoWhite from '../../../../assets/images/LogoWhite.png';
import SecondaryLogoWhite from '../../../../assets/images/SecondaryLogoWhite.png';

import { Row, SmallHeightDivider } from '../../../../theme/Styles';
import { FooterTextContent } from './FooterConstants';
import { useQuery } from 'react-query';
import { getInfoFooter } from '../../../../api/Home';


function Footer() {
  const history = useHistory();
  const { data: infoFooter, isLoading: infoFooterIsLoading } = useQuery(['infoFooter'], () => getInfoFooter());

  return (
    <FooterContainer>
      <CenterContainer>
        <LogosContainer>
          <Image src={LogoWhite} />
          <Divider />
          <Image src={SecondaryLogoWhite} />
        </LogosContainer>
        {infoFooter?.map((item) => (
          <>
            <strong>
              <FooterText>{item.title}</FooterText>
            </strong>
            <FooterText>{item.address}</FooterText>
            <FooterText>
              Tel.: {item.phone} | Whatsapp: +{item.whatsapp}
            </FooterText>
            <FooterText>{item.email}</FooterText>
            <Row>
              <LinkText onClick={() => history.push('/app/termsOfUse')}>
                {item.term}
              </LinkText>
              <TextDivider />
              <LinkText onClick={() => history.push('/app/policy')}>
                | {item.politicsPrivacy}|
              </LinkText>
              <TextDivider />
              <LinkText onClick={() => history.push('/app/frequentQuestions')}>
                {item.questionFrequently}
              </LinkText>
            </Row>
            <FooterText>
              @{process.env.REACT_APP_CONFIG_YEAR} {item.piePage}
            </FooterText>
          </>
        ))}
        <SmallHeightDivider />
   
        <SmallHeightDivider />
      </CenterContainer>
    </FooterContainer>
  );
}

export default Footer;
